import { getBooleanEnv } from "@/config/env"

export const logger = (...args: any[]) => {
  if (getBooleanEnv("VITE_DEV_SHOW_CONSOLE_LOGS"))
    console.log(...args)
}
